import { api } from '@/lib/api-client';

export interface SampleDocumentsResponse {
  documents: Array<{ fieldValues: Record<string, unknown> }>;
  sampleBatchId: string | null;
  recordCount: number;
}

// Routes through `api` so 401s bounce to Suite SSO.
export async function fetchSampleDocuments(jobTypeId: string): Promise<SampleDocumentsResponse> {
  return api.get<SampleDocumentsResponse>(`/job-types/${jobTypeId}/sample-documents`);
}
